import { useMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import {
  PriceControlAggregatedDTO,
  PriceControlChangeType,
  PriceControlSupplierAggregatedDTO,
} from '@retail/price-control/types';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

export function useFetchPriceControlAggregated(
  assortmentId: number,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<PriceControlAggregatedDTO>({
    method: 'GET',
    queryKey: ['price-control-aggregated', assortmentId],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.priceControl.assortment.assortmentId.getFullLinkPath({ assortmentId }),
    }),
    ...queryOptions,
  });
}

interface PriceControlFilters {
  changeTriggerType?: PriceControlChangeType;
  itemSearch?: string;
  productGroupId?: string;
  discountGroupId?: string;
  changeDateLessThanOrEqual?: string;
  changeDateGreaterThanOrEqual?: string;
  purchasePriceChangeLower?: number;
  purchasePriceChangeUpper?: number;
  salesPriceChangeLower?: number;
  salesPriceChangeUpper?: number;
  coverageDegreeChangeLower?: number;
  coverageDegreeChangeUpper?: number;
  isHandledStatus: boolean;
}

interface FetchProps extends QueryOptions {
  assortmentId: number;
  supplierNumber: number;
  filters: PriceControlFilters;
}

export function useFetchPriceControlSupplierAggregated({
  assortmentId,
  supplierNumber,
  filters,
  ...queryOptions
}: FetchProps) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<PriceControlSupplierAggregatedDTO>({
    method: 'POST',
    queryKey: ['price-control-supplier-aggregated', assortmentId, supplierNumber, filters],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.priceControl.assortment.assortmentId.supplier.supplierNumber.getFullLinkPath({
        assortmentId,
        supplierNumber,
      }),
    }),
    body: filters,

    ...queryOptions,
  });
}
